module.exports = __webpack_public_path__ + "static/media/whitebit.56aa7f43.svg";